import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Modal from '../../../components/ui/Modal';

const ExportModal = ({ onClose, onExport, itemCount }) => {
  const [selectedFormat, setSelectedFormat] = useState('json');

  const formats = [
    {
      id: 'json',
      label: 'JSON',
      description: 'Structured data format for developers',
      icon: 'Code'
    },
    {
      id: 'csv',
      label: 'CSV',
      description: 'Spreadsheet-compatible format',
      icon: 'Table'
    },
    {
      id: 'pdf',
      label: 'PDF',
      description: 'Printable document format (Coming Soon)',
      icon: 'FileText',
      disabled: true
    }
  ];

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Export Content Library"
      description={`Export ${itemCount} content items in your preferred format`}
      type="info"
      icon="Download"
      actions={
        <>
          <Button variant="outline" onClick={onClose} fullWidth>
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={() => onExport(selectedFormat)}
            disabled={formats?.find(f => f?.id === selectedFormat)?.disabled}
            fullWidth
          >
            Export as {selectedFormat?.toUpperCase()}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        {formats?.map((format) => (
          <button
            key={format?.id}
            onClick={() => !format?.disabled && setSelectedFormat(format?.id)}
            disabled={format?.disabled}
            className={`
              w-full p-4 rounded-lg border-2 transition-all duration-250 text-left
              ${selectedFormat === format?.id
                ? 'border-primary bg-primary/5' :'border-border bg-transparent hover:border-primary/50'
              }
              ${format?.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <div className="flex items-start gap-3">
              <div className={`
                w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0
                ${selectedFormat === format?.id ? 'bg-primary/10' : 'bg-muted'}
              `}>
                <Icon
                  name={format?.icon}
                  size={20}
                  color={selectedFormat === format?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="font-semibold text-foreground">{format?.label}</h4>
                  {format?.disabled && (
                    <span className="text-xs px-2 py-0.5 bg-muted text-muted-foreground rounded-full">
                      Coming Soon
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground">{format?.description}</p>
              </div>
              {selectedFormat === format?.id && (
                <Icon name="CheckCircle" size={20} color="var(--color-primary)" />
              )}
            </div>
          </button>
        ))}
      </div>
    </Modal>
  );
};

export default ExportModal;